module.exports = __webpack_public_path__ + "static/img/gpt6.7cb96b1a.jpg";